import client from '@/services/api/client'
import { IdValueObject } from '@/interfaces/app/ValueObjects'
import { createErrorMessage } from '@/services/location/'

export interface AddressCMService {
  getRegions(): Promise<IdValueObject[] | void>
  getDistricts(regionId: number): Promise<IdValueObject[] | void>
  getMunicipalities(districtId: number): Promise<IdValueObject[] | void>
  getStreets(municipalityId: number): Promise<string[] | void>
  getHouseNumbers(
    municipalityId: number,
    street: string
  ): Promise<IdValueObject[] | void>
}

export const AddressCM: AddressCMService = {
  async getRegions() {
    try {
      const { data } = await fetchRegions()
      return data
    } catch {
      createErrorMessage()
    }
  },

  async getDistricts(regionId: number) {
    try {
      const { data } = await fetchDistricts(regionId)
      return data
    } catch {
      createErrorMessage()
    }
  },

  async getMunicipalities(districtId: number) {
    try {
      const { data } = await fetchMunicipalities(districtId)
      return data
    } catch {
      createErrorMessage()
    }
  },

  async getStreets(municipalityId: number) {
    try {
      const { data } = await fetchStreets(municipalityId)
      return data
    } catch {
      createErrorMessage()
    }
  },

  async getHouseNumbers(municipalityId: number, street: string) {
    try {
      const { data } = await fetchHouseNumbers(municipalityId, street)
      return data
    } catch {
      createErrorMessage()
    }
  },
}

async function fetchRegions() {
  return client({
    url: `/v1/location/AddressCM/regions`,
    method: 'GET',
  })
}

async function fetchDistricts(regionId: number) {
  return client({
    url: `/v1/location/AddressCM/regions/${regionId}/districts`,
    method: 'GET',
  })
}

async function fetchMunicipalities(districtId: number) {
  return client({
    url: `/v1/location/AddressCM/districts/${districtId}/municipalities`,
    method: 'GET',
  })
}

async function fetchStreets(municipalityId: number) {
  return client({
    url: `/v1/location/AddressCM/municipalities/${municipalityId}/streets`,
    method: 'GET',
  })
}

async function fetchHouseNumbers(municipalityId: number, street: string) {
  return client({
    url: `/v1/location/AddressCM/municipalities/${municipalityId}/streets/${street}/addresses`,
    method: 'GET',
  })
}
